import React, { useState } from 'react';
import './AddSchoolModal.css';
import { API_BASE_URL as API_URL } from '../config/apiBase';


const AddSchoolModal = ({ isOpen, onClose, onSchoolAdded }) => {
  const [formData, setFormData] = useState({
    entity_name: '',
    is_org_entity: false,
    description: '',
    location: '',
    contact_email: '',
    contact_phone: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    // Clear error when user starts typing
    if (error) setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.entity_name.trim()) {
      setError('Entity name is required');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_URL}/admin/entities`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to create entity');
      }

      // Success - reset form and close modal
      setFormData({
        entity_name: '',
        is_org_entity: false,
        description: '',
        location: '',
        contact_email: '',
        contact_phone: ''
      });
      onClose();
      onSchoolAdded(data.data);
      
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) {
      setFormData({
        entity_name: '',
        is_org_entity: false,
        description: '',
        location: '',
        contact_email: '',
        contact_phone: ''
      });
      setError('');
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="add-school-modal-overlay" onClick={handleClose}>
      <div className="add-school-modal" onClick={(e) => e.stopPropagation()}>
        <div className="add-school-modal-header">
          <h2>Add New Entity</h2>
          <button 
            className="add-school-modal-close" 
            onClick={handleClose}
            disabled={loading}
          >
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="add-school-form">
          <div className="add-school-form-content">
            <div className="form-group">
              <label htmlFor="entity_name" className="form-label">
                Entity Name *
              </label>
              <input
                type="text"
                id="entity_name"
                name="entity_name"
                value={formData.entity_name}
                onChange={handleInputChange}
                className="form-input"
                placeholder="Enter entity name"
                required
                disabled={loading}
              />
            </div>

            <div className="form-group">
              <label className="form-checkbox-label">
                <input
                  type="checkbox"
                  name="is_org_entity"
                  checked={formData.is_org_entity}
                  onChange={handleInputChange}
                  disabled={loading}
                  className="form-checkbox"
                />
                <span>Organization Entity</span>
              </label>
            </div>

            {/* <div className="form-group">
              <label htmlFor="description" className="form-label">
                Description
              </label>
              <textarea
                id="description"
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                className="form-textarea"
                placeholder="Enter school description (optional)"
                rows={3}
                disabled={loading}
              />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="location" className="form-label">
                  Location
                </label>
                <input
                  type="text"
                  id="location"
                  name="location"
                  value={formData.location}
                  onChange={handleInputChange}
                  className="form-input"
                  placeholder="City, State"
                  disabled={loading}
                />
              </div>

              <div className="form-group">
                <label htmlFor="contact_phone" className="form-label">
                  Contact Phone
                </label>
                <input
                  type="tel"
                  id="contact_phone"
                  name="contact_phone"
                  value={formData.contact_phone}
                  onChange={handleInputChange}
                  className="form-input"
                  placeholder="Phone number"
                  disabled={loading}
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="contact_email" className="form-label">
                Contact Email
              </label>
              <input
                type="email"
                id="contact_email"
                name="contact_email"
                value={formData.contact_email}
                onChange={handleInputChange}
                className="form-input"
                placeholder="contact@school.edu"
                disabled={loading}
              />
            </div> */}

            {error && (
              <div className="form-error">
                {error}
              </div>
            )}
          </div>

          <div className="add-school-modal-actions">
            <button
              type="button"
              onClick={handleClose}
              className="btn btn-secondary"
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading || !formData.entity_name.trim()}
            >
              {loading ? (
                <>
                  <span className="spinner"></span>
                  Creating...
                </>
              ) : (
                'Create Entity'
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddSchoolModal;
